import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/configuration/vendor-management/suppliers')({
    staticData: {
        metadata: {
            title: 'Suppliers',
        },
        modules: ['claim'],
        permissions: ['settings:update'],
    },
    component: Outlet,
});
